export const getErrorPromiseState = (error) => ({
    error,
    isError: true,
    isLoading: false,
    isSuccess: false,
    status: 'error',
});
export const getInitialPromiseState = (data) => ({
    data,
    isError: false,
    isLoading: true,
    isSuccess: false,
    status: 'loading',
});
export const getSuccessPromiseState = (data) => ({
    data,
    isError: false,
    isLoading: false,
    isSuccess: true,
    status: 'success',
});
//# sourceMappingURL=promiseUtils.js.map